import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import companyService from "../services/companyService";

const initialState = {
    companies: [],
    company: null,
    loading: false,
    error: null,
};

const companySlice = createModule({
    name: "companies",
    initialState,
    reducers: {
        create: (state) => {
            state.loading = true;
            state.error = null;
        },
        update: (state) => {
            state.loading = true;
            state.error = null;
        },
        delete: (state) => {
            state.loading = true;
            state.error = null;
        },
        getById: (state) => {
            state.loading = true;
            state.error = null;
        },
        getAll: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchedCompany: (state, payload) => {
            state.loading = false;
            state.company = payload;
        },
        fetchedCompanies: (state, payload) => {
            state.loading = false;
            state.companies = payload;
        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action.payload || "An error occurred";
        },
    },
    sagas: (A) => ({
        *[A.create]({ payload }) {
            try {
                const { data } = yield call(companyService.create, payload.data);
                yield put(A.fetchedCompany(data));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.fetchError(error?.response?.data?.message || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.update]({ payload }) {
            try {
                const { data } = yield call(companyService.update, payload.data);
                yield put(A.fetchedCompany(data));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.fetchError(error?.response?.data?.message || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.delete]({ payload }) {
            try {
                yield call(companyService.delete, payload.id);
                yield put(A.finishFetching());
                if (payload.onSuccess) {
                    yield call(payload.onSuccess);
                }
            } catch (error) {
                yield put(A.fetchError(error?.response?.data?.message || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.getById]({ payload }) {
            try {
                const { data } = yield call(companyService.getById, payload.id);
                yield put(A.fetchedCompany(data));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.fetchError(error?.response?.data?.message || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },

        *[A.getAll]({ payload }) {
            try {
                const { data } = yield call(companyService.getAll);
                yield put(A.fetchedCompanies(data));
                if (payload?.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.fetchError(error?.response?.data?.message || error.message));
                if (payload?.onError) {
                    yield call(payload.onError, error);
                }
            }
        },
    }),
});

export default companySlice;
export const companyActions = companySlice.actions;
export const companySelectors = {
    getCompanies: (state) => state.companies?.companies || [],
    getCompany: (state) => state.companies?.company || null,
    getCompaniesLoading: (state) => state.companies?.loading || false,
    getCompaniesError: (state) => state.companies?.error || null,
};
